<template>
  <div class="choosetype">
    <headerBar title="类型选择"></headerBar>
    <div class="list">
      <router-link :to="'/uploadproject?typeid=' + item.id" v-for="(item, index) in type_list" :key="index" class="item kuang" :style="{ 'border-color': color_list[index % 4] }">
        <div class="bgmask" :style="{ 'background-color': color_list[index % 4] }"></div>
        <p :style="{ color: color_list[index % 4] }">{{ item.name }}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type_list: [],
      color_list: ['#299e72', '#7092f4', '#31bee1', '#f58080']
    };
  },
  created() {
    //判断登陆状态,
    if (!window.localStorage.getItem('is_check_login') || window.localStorage.getItem('is_check_login') == 0) {
      //登陆失败
      this.$router.push('/login');
    } else {
      this.getTypeList();
    }
  },
  methods: {
    getTypeList() {
      this.$request.post('/front/Sundries/slists', {}, res => {
        console.log(res);
        if (res.status == 1) {
          this.type_list = res.result;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.choosetype {
  padding-top: 0.8rem;
  border: 1px solid transparent;
  .list {
    margin-top: 1rem;
    .kuang {
      display: flex;
      align-items: center;
      border: 1px solid #299e72;
      overflow: hidden;

      .bgmask {
        position: absolute;
        left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/choosetype.vue